module.exports = __webpack_public_path__ + "static/img/gift-3.7c15d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-3.png
// module id = 363
// module chunks = 140